module.exports = __webpack_public_path__ + "img/traverse-board.168c33ee.jpg";